<template lang='pug'>
  .reqest-trial(id='requestTrialSection')
    v-row(justify='center' align='center').form-row
      v-col(cols='11' sm='10' lg='6')
        v-card
          v-card-title(v-if='submitted')
            .display-1.font-weight-thin.grey--text.text--darken-2 Request Trial
          v-card-text(v-if='submitted')
            .subheading.grey--text.text--darken-2 Thank you for your interest! We'll reach out to you shortly at&nbsp;
              strong {{trial.email}}
          form#requestTrialForm(@submit.prevent='requestTrial' v-if='!submitted')
            v-card-title
              .display-1.font-weight-thin.grey--text.text--darken-2 Request Trial
            v-card-text
              v-text-field(prepend-icon='person' label='First Name' v-model='trial.firstName' required)
              v-text-field(prepend-icon='person' label='Last Name' v-model='trial.lastName' required)
              v-text-field.mb-6(label='Work Email' prepend-icon='email' v-model='trial.email' type='email' required persistent-hint hint='email@yourcompany.com')
              v-text-field(prepend-icon='link' label='Link to Your Website or Application' v-model='trial.link' required)
              div.g-recaptcha(data-sitekey='6Le0DeAUAAAAAJe3ipDSk8EQn8k7jFPy1jZT-szi')
              //v-textarea(outlined label='Tell Us About Your Business' v-model='trial.about' type='text' auto-grow rows='4' placeholder='Optional' )
            v-card-actions
              .caption.grey--text.darken-2 Or you can email us at&nbsp;
                a(href='mailto:hello@bionicmetrics.com') hello@bionicmetrics.com
              v-spacer
              v-btn.flush-right(color='accent' :loading='loading' dark type='submit') Submit
</template>

<script>
import BottomArch from './BottomArch';
import YetAnotherArch from './YetAnotherArch';
import System from '../api/system';
import Notifications from '../services/notification.service';
import VideoDemo from './VideoDemo';

export default {
  name: 'RequestTrial',
  components: {VideoDemo, YetAnotherArch, BottomArch},
  methods: {
    async requestTrial() {
      try {
        this.loading = true;
        // eslint-disable-next-line no-undef
        await System.requestTrial(this.trial.email, `${this.trial.firstName} ${this.trial.lastName}`, this.trial.link, grecaptcha.getResponse());
        this.submitted = true;
      } catch (e) {
        Notifications.alert('There was an ironic error when submitting your request for a trial. Would you do us a favor and email us at support@bionicmetrics.com to request a trial?');
      } finally {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      loading: false,
      submitted: false,
      trial: {
        link: null,
        name: null,
        email: null,
        about: null
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .reqest-trial {
    background-color: #FFFFFF;
  }

  .form-row {
    min-height: 50vh;
  }
</style>
